export enum UserRole {
  ADMIN = "admin"
}
